import {
  EDIT_LANDING_REQUEST,
  EDIT_LANDING_SUCCESS,
  EDIT_LANDING_FAILED,
  GET_LANDING_REQUEST,
  GET_LANDING_FAILED,
  GET_LANDING_SUCCESS,
} from './actionTypes';

const initialState = {
  landing: null,
  loading: false,
  error: null,
};

const createInitiativeReducer = (state = initialState, {
  type, error, landing,
}) => {
  switch (type) {
    case EDIT_LANDING_REQUEST:
      return { ...state, loading: true };
    case EDIT_LANDING_SUCCESS:
      return {
        ...state,
        loading: false,
        landing: null,
      };
    case EDIT_LANDING_FAILED:
      return { ...state, loading: false, error };
    case GET_LANDING_REQUEST:
      return { ...state, loading: true, landing: null };
    case GET_LANDING_SUCCESS:
      return {
        ...state, loading: false, landing,
      };
    case GET_LANDING_FAILED:
      return {
        ...state,
        loading: false,
        error,
      };

    default:
      return state;
  }
};

export default createInitiativeReducer;
